/*
 * Silph TCG — éclate le filtre unique « Série » en plusieurs groupes lisibles.
 *
 * Shopify n'expose qu'UN seul groupe de filtre par balises. Les balises de la
 * boutique sont donc toutes mélangées dans « Série » : extensions, types
 * d'objet et noms de Pokémon. On les a préfixées (`Série: …`, `Type: …`) ;
 * ce script les répartit en groupes distincts au moment de l'affichage.
 *
 * Principe : on DÉPLACE les <li> existants, sans jamais toucher aux <input>.
 * Ils gardent leur `name="filter.p.tag"` et leur `value`, donc le formulaire
 * de filtrage de Dawn continue de fonctionner tel quel — desktop et mobile.
 */
(function () {
  'use strict';

  // Préfixe de balise → titre affiché. Ajouter une ligne suffit à créer un groupe.
  var GROUPES = [
    { prefixe: 'Série:', titre: 'Série' },
    { prefixe: 'Type:', titre: 'Type d’objet' },
  ];

  function libelle(li) {
    var el = li.querySelector('.facet-checkbox__text-label');
    return el ? el.textContent.trim() : '';
  }

  function retirerPrefixe(li, prefixe) {
    var court = libelle(li).slice(prefixe.length).trim();
    var visible = li.querySelector('.facet-checkbox__text-label');
    if (visible) visible.textContent = court;
    var cache = li.querySelector('.visually-hidden');
    if (cache) cache.textContent = cache.textContent.replace(prefixe, '').trim();
    // Dawn masque les valeurs au-delà de la 10e derrière un « voir plus » ;
    // nos groupes sont défilables, on réaffiche tout.
    li.classList.remove('show-more-item', 'hidden');
  }

  function traiter(bloc) {
    if (bloc.dataset.silphGroupes === 'ok') return;
    var items = Array.from(bloc.querySelectorAll('li'));
    if (!items.length) return;

    // Ce bloc filtre-t-il bien par balise ?
    var estBalise = items.some(function (li) {
      var i = li.querySelector('input[name="filter.p.tag"]');
      return !!i;
    });
    if (!estBalise) return;

    var repartis = GROUPES.map(function (g) {
      return { def: g, items: items.filter(function (li) { return libelle(li).indexOf(g.prefixe) === 0; }) };
    }).filter(function (g) { return g.items.length > 0; });

    if (!repartis.length) return; // aucune balise préfixée : on ne touche à rien

    var liste = bloc.querySelector('ul');
    var apres = bloc;

    repartis.forEach(function (g) {
      var copie = bloc.cloneNode(false); // même <details>, mêmes classes
      copie.removeAttribute('id');
      copie.dataset.silphGroupes = 'ok';
      copie.open = false;

      var resume = bloc.querySelector('summary').cloneNode(true);
      // Desktop : le titre est dans `.facets__summary-label`.
      // Mobile : c'est le premier <span> du <div>, sans classe (le second
      // porte la flèche). Deux structures, un seul traitement.
      var etiquette = resume.querySelector('.facets__summary-label');
      if (!etiquette) {
        etiquette = Array.prototype.find.call(
          resume.querySelectorAll('summary > div > span, div > span'),
          function (s) { return !s.classList.contains('mobile-facets__arrow'); }
        );
      }
      if (etiquette) {
        var compteur = etiquette.querySelector('.facets__selected');
        etiquette.textContent = g.def.titre + ' ';
        if (compteur) etiquette.appendChild(compteur);
      }
      // Pas de flèche à rajouter : `cloneNode(true)` a déjà copié celle du
      // résumé d'origine. En ajouter une seconde en affichait deux.
      copie.appendChild(resume);

      // On reconstruit toute la chaîne de conteneurs qui sépare <details> de <ul> :
      // un seul niveau en mobile (`.mobile-facets__submenu.gradient`), deux sur
      // ordinateur (`.facets__display-vertical` > `.facets-wrap`). Cibler des classes
      // en dur, ou ne cloner qu'un niveau, faisait perdre des règles de mise en forme —
      // c'est ce qui rendait les coches étranges en mobile.
      var chaine = [];
      for (var n = liste ? liste.parentElement : null; n && n !== bloc; n = n.parentElement) chaine.unshift(n);

      var racine = null;
      var courant = null;
      chaine.forEach(function (niveau) {
        var c = niveau.cloneNode(false);
        c.removeAttribute('id');
        if (courant) courant.appendChild(c);
        else racine = c;
        courant = c;
      });

      var nouvelleListe = liste ? liste.cloneNode(false) : document.createElement('ul');
      nouvelleListe.removeAttribute('id');
      g.items.forEach(function (li) {
        retirerPrefixe(li, g.def.prefixe);
        nouvelleListe.appendChild(li);
      });

      if (courant) {
        // Le conteneur profond ne contient pas QUE la liste : en mobile il porte
        // aussi le bouton retour et le pied de panneau (« Effacer » / « Appliquer »).
        // On recopie tous ses enfants dans l'ordre, la liste étant remplacée par la nôtre.
        Array.prototype.forEach.call(liste.parentElement.children, function (enfant) {
          if (enfant === liste) {
            courant.appendChild(nouvelleListe);
          } else {
            var c = enfant.cloneNode(true);
            c.removeAttribute('id');
            courant.appendChild(c);
          }
        });
        copie.appendChild(racine);
      } else {
        copie.appendChild(nouvelleListe);
      }
      copie.classList.add('silph-facet-groupe');

      apres.parentNode.insertBefore(copie, apres.nextSibling);

      // Dawn attache ses écouteurs au chargement de la page ; nos groupes naissent
      // après, leurs `summary` n'en ont donc aucun. En mobile, c'est ce qui empêchait
      // le sous-panneau de coulisser (`menu-opening` jamais posé) : le filtre semblait
      // ne plus marcher. On rebranche les gestionnaires du `<menu-drawer>` parent —
      // ceux de Dawn, pas une réimplémentation — sur nos seuls nouveaux éléments,
      // pour ne pas doubler ceux des facettes d'origine.
      var tiroir = copie.closest('menu-drawer');
      if (tiroir && typeof tiroir.onSummaryClick === 'function') {
        resume.addEventListener('click', tiroir.onSummaryClick.bind(tiroir));
        copie
          .querySelectorAll('button:not(.localization-selector):not(.country-selector__close-button)')
          .forEach(function (bouton) {
            bouton.addEventListener('click', tiroir.onCloseButtonClick.bind(tiroir));
          });
      }

      apres = copie;
    });

    // Les valeurs restantes ne sont pas préfixées (noms de Pokémon, balises
    // techniques) : elles n'ont rien à faire dans un filtre client.
    bloc.remove();
  }

  /*
   * Fermeture du tiroir de filtres mobile dès qu'une valeur est choisie.
   * Par défaut Dawn laisse le panneau ouvert : on coche, rien ne semble se
   * passer, il faut trouver « Appliquer » pour revenir aux produits. On ferme
   * donc automatiquement, en laissant à Dawn le temps de lancer son filtrage.
   * Les champs de prix sont exclus : on y saisit deux bornes à la suite.
   */
  function fermerApresChoix() {
    var tiroir = document.querySelector('menu-drawer.mobile-facets__wrapper');
    if (!tiroir || tiroir.dataset.silphFermeture === 'ok') return;
    if (typeof tiroir.closeMenuDrawer !== 'function') return;
    tiroir.dataset.silphFermeture = 'ok';

    // Fermeture à la main. Testé : après le re-rendu des facettes, ni
    // `closeMenuDrawer()` ni un clic sur le `summary` ne ferment quoi que ce
    // soit — leurs gestionnaires sont restés attachés aux éléments remplacés.
    // On repose donc l'état nous-mêmes, y compris le défilement de la page que
    // Dawn bloque à l'ouverture.
    /*
     * Rend la page défilable. Dawn ne pose PAS `overflow-hidden` sur le <body>
     * mais `overflow-hidden-<breakpoint>` (voir global.js : la classe est
     * composée à partir de `data-breakpoint`, ici « mobile »). Ne retirer que
     * `overflow-hidden` laissait donc le <body> en `overflow: hidden` : après
     * un filtre, impossible de faire défiler la page pour voir les résultats.
     */
    function libererDefilement() {
      var point = tiroir && tiroir.dataset ? tiroir.dataset.breakpoint : null;
      document.body.classList.remove('overflow-hidden');
      if (point) document.body.classList.remove('overflow-hidden-' + point);
      document.body.classList.remove('overflow-hidden-mobile', 'overflow-hidden-tablet');
    }

    function fermer() {
      var boite = document.querySelector('details.mobile-facets__disclosure');
      if (!boite || !boite.open || boite.dataset.silphFermetureEnCours === 'ok') return;
      boite.dataset.silphFermetureEnCours = 'ok';

      // Le panneau glisse grâce à `transition: transform 0.2s` sur
      // `.mobile-facets__inner`, déclenchée par le retrait de `menu-opening`.
      // Replier le <details> tout de suite couperait l'animation : d'où l'à-coup.
      // On retire d'abord la classe, on laisse glisser, puis on replie.
      boite.querySelectorAll('.mobile-facets__details').forEach(function (d) {
        d.classList.remove('menu-opening');
      });
      boite.querySelectorAll('.mobile-facets__main').forEach(function (m) {
        m.classList.remove('submenu-open');
      });
      boite.classList.remove('menu-opening');

      // On rend la page défilable dès le début du glissement : attendre la fin
      // du repli laissait l'écran figé une seconde de plus, ce qui se ressent
      // comme un blocage même si le panneau est déjà parti.
      libererDefilement();

      var interieur = boite.querySelector('.mobile-facets__inner');
      var termine = false;
      function replier() {
        if (termine) return;
        termine = true;
        boite.querySelectorAll('.mobile-facets__details').forEach(function (d) {
          d.open = false;
        });
        boite.open = false;
        delete boite.dataset.silphFermetureEnCours;
        libererDefilement();
      }

      if (interieur) {
        interieur.addEventListener('transitionend', replier, { once: true });
      }
      // Filet : si la transition n'est pas jouée (préférence « animations réduites »,
      // onglet en arrière-plan), on replie quand même.
      setTimeout(replier, 320);
    }

    tiroir.addEventListener('change', function (evt) {
      var cible = evt.target;
      if (!cible || !cible.matches) return;
      if (!cible.matches('input[name^="filter."]')) return;
      if (cible.type !== 'checkbox' && cible.type !== 'radio') return;

      // Dawn remplace tout le bloc de facettes après filtrage et rouvre le
      // tiroir au passage : fermer tout de suite ne servirait à rien. On attend
      // que la grille de produits ait été re-rendue.
      var grille = document.getElementById('ProductGridContainer') || document.querySelector('.collection');
      if (!grille) {
        setTimeout(fermer, 400);
        return;
      }
      var observateur = new MutationObserver(function () {
        observateur.disconnect();
        setTimeout(fermer, 80);
      });
      observateur.observe(grille, { childList: true, subtree: true });
      // Filet de sécurité si le rendu n'émet aucune mutation détectable.
      setTimeout(function () {
        observateur.disconnect();
        fermer();
      }, 2500);
    });
  }

  /*
   * Pastilles de filtres actifs. Dawn les libelle « <nom du filtre> : <valeur> ».
   * Comme nos balises portent déjà leur propre préfixe, on obtenait des doublons
   * du genre « Série: Type: ETB ». On réécrit le texte avec le nom du groupe.
   */
  function nettoyerPastilles() {
    document.querySelectorAll('.active-facets__button-inner').forEach(function (pastille) {
      Array.prototype.forEach.call(pastille.childNodes, function (noeud) {
        if (noeud.nodeType !== 3) return;
        var texte = noeud.nodeValue;
        GROUPES.forEach(function (g) {
          var i = texte.indexOf(g.prefixe);
          if (i === -1) return;
          noeud.nodeValue = ' ' + g.titre + ' : ' + texte.slice(i + g.prefixe.length).trim() + ' ';
        });
      });
    });
  }

  function balayer() {
    document.querySelectorAll('details.js-filter, .mobile-facets__details').forEach(traiter);
    nettoyerPastilles();
    fermerApresChoix();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', balayer);
  } else {
    balayer();
  }

  // Dawn remplace tout le bloc de facettes après chaque filtrage.
  var obs = new MutationObserver(function (m) {
    for (var i = 0; i < m.length; i++) if (m[i].addedNodes.length) { balayer(); return; }
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();
